export function shuffle (array) {
  const clone = array.slice()
  for (let i = clone.length - 1; i > 0; i -= 1) {
    const j = Math.floor(Math.random() * (i + 1));
    [clone[i], clone[j]] = [clone[j], clone[i]]
  }
  return clone
}

export function avoidRepeats (arr) {
  for (let i = 2; i < arr.length; i++) {
    while (arr[i] === arr[i - 1] && arr[i] === arr[i - 2]) {
      arr[i] = pick(arr)
    }
  }
  return arr
}

export function pick (array) {
  return array[Math.floor(Math.random() * array.length)]
}

export function uniq (array) {
  return array.filter((v, i) => array.indexOf(v) === i)
}

export function exclude (array, excludes) {
  return array.filter(v => excludes.indexOf(v) < 0)
}

// modified from https://www.sitepoint.com/community/t/javascript-array-polyfills/193601
export function getKeys (array) {
  let k = 0
  return {
    length: array.length,
    next () {
      return array.length
        ? { value: (k += 1), done: false }
        : { done: true }
    }
  }
}

export function countValues (array) {
  return array.reduce((map, value) => {
    map[value] = (map[value] || 0) + 1
    return map
  }, {})
}

export function sortObjectByKey (o) {
  return Object.keys(o).sort().reduce((r, k) => {
    r[k] = o[k]
    return r
  }, {})
}
